var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { HTTPRequestMethod } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { audioSelect } from 'components/shared/audio/reducers/audio';
import { FlowType } from 'fable/flowEditor';
import { Integration, } from '../../components/modals/integration';
import { ContentType } from '../../components/types';
import { validate } from './validators/integration';
const FORM_NAME = 'flowFetchDataForm';
export default (flowType = FlowType.FLOW_TYPE_CALL) => {
    const mapStateToProps = (state, props) => {
        var _a, _b, _c;
        const payload = props.node.payload
            ? props.node.payload
            : {
                body: '',
                contentType: ContentType.APPLICATION_JSON,
                headers: {},
                httpRequestType: HTTPRequestMethod.Get,
                nextNodeId: null,
                url: '',
                variables: [],
            };
        const variablesWithLocks = [];
        const { descendantNeeds } = props.scopeVars;
        payload.variables.forEach((variable) => {
            const cantDelete = descendantNeeds.includes(variable.id);
            variablesWithLocks.push(Object.assign(Object.assign({}, variable), { type: 'scope', locked: cantDelete }));
        });
        const initalHeaders = [];
        if (payload.headers) {
            Object.entries(payload.headers).forEach(([key, value]) => {
                initalHeaders.push({
                    key,
                    value,
                });
            });
        }
        const { announcement, headers, variables, nextNodeId } = payload, payloadFormValues = __rest(payload, ["announcement", "headers", "variables", "nextNodeId"]);
        const form = state.form[FORM_NAME];
        const initialValues = Object.assign(Object.assign(Object.assign({}, payloadFormValues), { contentType: payloadFormValues.contentType || ContentType.APPLICATION_JSON, httpRequestType: payloadFormValues.httpRequestType || HTTPRequestMethod.Get, body: payloadFormValues.body || '', variables: variablesWithLocks, headers: initalHeaders }), (flowType === FlowType.FLOW_TYPE_CALL &&
            announcement && {
            announcement: {
                author: ((_a = announcement.file) === null || _a === void 0 ? void 0 : _a.author) || '',
                url: ((_b = announcement.file) === null || _b === void 0 ? void 0 : _b.url) || '',
                label: ((_c = announcement.file) === null || _c === void 0 ? void 0 : _c.filename) || '',
            },
        }));
        return {
            payload,
            initialValues,
            formValues: (form === null || form === void 0 ? void 0 : form.values) || initialValues,
            flowType,
        };
    };
    const mapDispatchToProps = (dispatch) => {
        return {
            audioSelect: (payload) => dispatch(audioSelect(payload)),
        };
    };
    return connect(mapStateToProps, mapDispatchToProps)(reduxForm({
        form: FORM_NAME,
        enableReinitialize: true,
        validate,
    })(Integration));
};
